<template>
    <ul class="sweet-bar">
        <li
            v-for="(item, index) of sweetness"
            :key="index"
            @click="setSweetness(item)"
            class="sweet-list"
        >
            <p :class="{ active: item.Name === activeSweet }">
                {{ item.Name }}%
            </p>
        </li>
    </ul>
</template>

<script>
export default {
    name: "Sweetness",
    props: {
        sweetness: Array,
        defaultValue: Number
    },
    data() {
        return {
            activeSweet: null,
        };
    },
    created() {
        this.setDefault();
    },
    methods: {
        setDefault() {
            this.activeSweet = this.defaultValue;
        },
        setSweetness(value) {
            this.activeSweet = value.Name;
            this.$emit("setSweetness", value);
        }
    }
};
</script>

<style lang="scss" scoped>
$light-brown: #a7907b;
$dark-brown: #4d341c;
.sweet-bar {
    background-color: rgba($color: #fff, $alpha: 0.3);
    font-size: 14px;
    border-radius: 10px;
    display: flex;
    flex-direction: row-reverse;
    list-style: none;
    color: #fff;
    justify-content: space-between;
    padding: 0px;
    margin: 0;
    height: 2rem;
    .sweet-list{
        p {
            margin: 0;
            padding: 0 16px;
            height: 2rem;
            display: flex;
            text-align: center;
            align-items: center;
            &.active {
                background-color: $light-brown;
                border-radius: 10px;
            }
        }
    }
}
</style>
